import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { Button, Flex } from '../design-system';

const Container = styled(Flex)`
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Text = styled.p`
  font-size: 1rem;
  margin: 1rem;
  text-align: center;
`;

const StyledButton = styled(Button)`
  width: 150px;
  margin-top: 0.8rem;
`;

interface NotAccessibleProps {
  redirect?: string | null;
  text?: string;
  buttonText?: string;
}

const NotAccessible = ({
  redirect = null,
  text = 'It looks like you have reached a page that does not exist.',
  buttonText = 'Go Back',
}: NotAccessibleProps) => {
  const navigate = useNavigate();
  return (
    <Container mt={3}>
      <Text>{text}</Text>
      <StyledButton
        onClick={redirect ? () => navigate(redirect) : () => navigate(-1)}
      >
        {buttonText || 'Go Back'}
      </StyledButton>
    </Container>
  );
};

export default NotAccessible;
